import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  cursor: pointer;
  user-select: none;
  font-size: 24px;
`;
